import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router'
import cx from 'classnames'
import Button from 'components/Button'
import Checkbox from 'components/Form/Checkbox'
import FormCollection from 'components/Form/Collection'
import DateComponent from 'components/Date'
import Input from 'components/Form/Input'
import Select from 'components/Form/Select'
import Textarea from 'components/Form/Textarea'
import classes from './NewDailyProduct.scss'

import moment, { urlFormat } from 'helpers/moment'
import { makeOptions } from 'helpers/components'
import { compareParseInt, guid } from 'helpers/index'

export class NewDailyProduct extends React.Component {
  constructor (props) {
    super(props)

    this.submitInputId = `submit-${guid()}`
    this._current_product = null
  }

  getCurrentProduct = (productId = this.props.fields.product_id.value) => {
    if (this._current_product && this._current_product.id === productId) return this._current_product

    const product = this.props.products.find(o => compareParseInt(o.product_id, productId))

    this._current_product = product
    return product
  };

  getUomOptions = () => {
    const type = this.getCurrentProduct() && this.getCurrentProduct().type
    const uoms = type && type.uoms && type.uoms.length && type.uoms || this.props.uoms

    return makeOptions(uoms)
  };

  getOptionOptions = () => {
    const type = this.getCurrentProduct() && this.getCurrentProduct().type
    const options = type && type.options && type.options.length && type.options || this.props.options

    return makeOptions(options)
  };

  changedProduct = productId => {
    const product = this.props.products.find(o => o.id === productId)

    if (product) {
      ['fishing_vessel', 'sourcing_method', 'sourcing_location', 'scientific_name', 'details', 'tasting_notes']
        .forEach(field => {
          if (product[field]) this.props.fields[field].onChange(product[field])
        })

      // remove each price on the product
      if (this.props.fields.prices.length) {
        this.props.fields.prices.map((price, index) => this.props.fields.prices.removeField(index))
      }

      if (product.prices && product.prices.length) {
        product.prices.map(price => {
          if (price.price) this.props.fields.prices.addField(price)
        })
      }

      this.props.fields.prices.addField({ price: undefined, uom_id: undefined, option_id: undefined })
    }
  };

  onChangeProduct = (...args) => {
    this.props.fields.product_id.onChange(...args)

    if (!args[0] || !args[0].value) return

    this.changedProduct(args[0].value)
  };

  render () {
    const className = cx({
      [classes['form']]: classes['form'],
      [classes['form--two-fifths']]: this.props.partial && classes['form--two-fifths'],
      [classes['form--partial']]: this.props.partial && classes['form--partial']
    })

    return <form onSubmit={this.props.handleSubmit} className={className}>
      <input type='submit' id={this.submitInputId} className={classes.hidden} />

      <header className={classes['header']}>
        <div className={classes['header-title']}>
          Adding a Daily Product

          <span className={classes['header-title--sub']}>
            <DateComponent {...this.props}
              date={this.props.fields.date.value}
              textFormat='for {0}'
              baseUrl='daily_products'
            />
          </span>
        </div>

        <div className={classes['header-buttons']}>
          <Button
            confirm
            options={['purple', 'small']}
            callback={() => this.props.copy(
              moment(this.props.fields.date.value).subtract(1, 'day').format(urlFormat),
              moment(this.props.fields.date.value).format(urlFormat)
            )}
          >
            Copy Yesterday
          </Button>
        </div>
      </header>

      <fieldset>
        <Select label='Product'
          placeholder='select a product'
          selectOptions={makeOptions(this.props.products)}
          {...this.props.fields.product_id}

          onChange={this.onChangeProduct}
        />

        <Checkbox
          label='Product in stock today?'
          {...this.props.fields.enabled}
        />

        <Input label='Scientific Name' placeholder='scientific name' {...this.props.fields.scientific_name} />
        <Input label='Additional Details' placeholder='sizing, etc' {...this.props.fields.details} />

        <Input label='Fishing Vessel' placeholder='fishing vessel' {...this.props.fields.fishing_vessel} />
        <Input label='Sourcing Method' placeholder='sourcing method' {...this.props.fields.sourcing_method} />
        <Input label='Sourcing Location' placeholder='sourcing location' {...this.props.fields.sourcing_location} />

        <Textarea label='Tasting Notes' placeholder='tasting notes' {...this.props.fields.tasting_notes} />

        <FormCollection
          label='Pricing'
          collection={this.props.fields.prices}
          defaultModel={{ price: undefined, uom_id: undefined, option_id: undefined }}
          fields={[
            { name: 'price', element: 'input', placeholder: 'price', pattern: '[0-9]+(\.[0-9]{0,})?' }, // eslint-disable-line no-useless-escape, max-len
            { name: 'uom_id', element: 'select', selectOptions: this.getUomOptions(), placeholder: 'uom' },
            { name: 'option_id', element: 'select', selectOptions: this.getOptionOptions(), placeholder: 'spec' }
          ]}
        />
      </fieldset>

      <footer className={classes['footer']}>
        <Button element={'label'} htmlFor={this.submitInputId} stick options={['green', 'block']}>
          Create Daily Product
        </Button>
      </footer>
    </form>
  }
}

NewDailyProduct.propTypes = {
  daily_product: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  uoms: PropTypes.array.isRequired,

  // react-redux
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,

  // actions
  copy: PropTypes.func.isRequired,

  partial: PropTypes.bool,

  location: PropTypes.object,
  params: PropTypes.object
}

NewDailyProduct.defaultProps = {
  partial: false
}

export default withRouter(NewDailyProduct)



// WEBPACK FOOTER //
// ./src/components/DailyProducts/New/NewDailyProduct.js